module.exports = __webpack_public_path__ + "70dd8d4278a1ea786f44de180a20da66.md";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./Changelog.md
// module id = 147
// module chunks = 0